import React from 'react';

import { Row } from './Row';

interface ClickableRowProps {
  label: string;
  children: React.ReactNode;
  onNavigate?: () => void;
}

// Thin alias of `Row` for navigable inputs. Kept distinct so callers can read
// the section markup as "this row is intended to link out" — visually the two
// are identical (both render as anchor placeholders with hover/active states).
export const ClickableRow: React.FC<ClickableRowProps> = ({
  label,
  children,
  onNavigate,
}) => (
  <Row label={label} onNavigate={onNavigate}>
    {children}
  </Row>
);
